export const officeConstant = {
    OFFICE_INVITE_REQUEST: 'OFFICE_INVITE_REQUEST',
    OFFICE_INVITE_SUCCESS: 'OFFICE_INVITE_SUCCESS',
    OFFICE_INVITE_FAILURE: 'OFFICE_INVITE_FAILURE'
};